import type { Networkish } from "@/types";
import { type Address, erc20Abi } from "viem";
import { usdtAbi } from "./usdt";

export function getERC20Abi(address: Address | undefined, chainId: Networkish) {
  return parseInt(`${chainId}`) === 1 && address && address === "0xdAC17F958D2ee523a2206206994597C13D831ec7" ? usdtAbi : erc20Abi;
}
